import { createRouter, createWebHistory } from "vue-router";

import authRouter from "./auth";
import settingsRouter from "./settings";
import notificationRouter from "./notification";
import documentRouter from "./document";
import submissionRouter from "./submission";
import templateRouter from "./template";
import usersRouter from "./users";
import logsRouter from "./logs";

import useAuthStore from "@/stores/auth";

import middlewarePipeline from "../helper/middleware/middleware-pipeline";
import auth from "@/helper/middleware/auth";
import admin from "@/helper/middleware/admin";
import fileVisibility from "@/helper/middleware/fileVisibility";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: { middleware: [auth] },
    },
    {
      path: "/health-monitoring",
      name: "health-monitoring",
      component: () => import("@/views/HealthMonitoringView.vue"),
      meta: { middleware: [auth, admin] },
    },
    {
      path: "/monitoring",
      name: "dashboardTransaction",
      component: () => import("@/views/DashboardTransaction.vue"),
      meta: { middleware: [auth, admin] },
    },
    {
      path: "/preview",
      children: [
        {
          path: "file/:id",
          name: "file-preview",
          component: () => import("@/views/FilePreview.vue"),
          props: true,
        },
        {
          path: "skck/:id",
          name: "skck-preview",
          component: () => import("@/views/SkckPreview.vue"),
          props: true,
        },
        {
          path: "document/:id",
          name: "document-preview",
          component: () => import("@/views/FileView.vue"),
          meta: { middleware: [fileVisibility] },
          props: true,
        },
      ],
    },
    ...authRouter,
    ...settingsRouter,
    ...notificationRouter,
    ...documentRouter,
    ...submissionRouter,
    ...templateRouter,
    ...usersRouter,
    ...logsRouter,
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: () => import("@/views/NotFound.vue"),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let store = useAuthStore().$state;
  // store.dispatch('status/loading', false)

  if (localStorage.getItem("key")) {
    store.token = localStorage.getItem("key");
    store.user = JSON.parse(localStorage.getItem("user"));
  }

  if (!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    store,
    router,
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});
export default router;
